<template>
  <view class="hot-city-main">
    <view style="height:22px"></view>
    <view class="city-title">{{title}}</view>
    <view class="city-container">
      <view
        wx:for="{{list}}"
        wx:key="index"
        class="city-container-item"
        wx:class="{{ {active:item.isChoosed} }}"
        bindtap="handleClick(item)"
      >{{ item.city_name }}
      </view>
    </view>
  </view>
</template>

<script>
  import { createComponent } from '@didi/es-mpx-creator'

  createComponent({
    props: {
      list: {
        type: Array,
        value: []
      },
      title: '',
      location: Object,
      useLocation: {
        type: Boolean,
        value: false
      }
    },
    methods: {
      /**
       * @description: 点击事件
       * @param {*} city
       */
      handleClick(city) {
        this.triggerEvent('handle', city)
      }
    }
  })
</script>

<style scoped lang="stylus" scoped>
  .hot-city-main
    margin-left 17px
    margin-right 14px
    font-size 14px
    font-weight normal
    color #333333
    font-family PingFangSC-Semibold
  .city-container
    margin-top 12px
    display grid
    grid-gap 8px
    grid-template-columns: repeat(3, 1fr)
    justify-items center 
    align-items center
    &-item
      width 100%
      height 36px
      box-sizing border-box
      line-height 36px
      background #F6F7F8
      border-radius 8px
      text-align center
      font-size 14px
      font-weight 400
      color #000000
      font-family Ping Fang SC
      &.active
        background #FFFFFF
        border 1px solid #FF6400
        position relative
        &:after
          content ''
          position absolute
          width 18px
          height 14px
          right -1px
          bottom -1px
          background-image url('https://dpubstatic.udache.com/static/dpubimg/sJ9KdDopDQpQoKQX0zqOD.png')
          background-size 100% 100%
    &:after
      content ''
      width 99px
      max-width 30%
      border 1px solid transparent
  .city-item
    height 35px
    line-height 35px
    background #FCFCFD
    border 1px solid #E5E5E5
    border-radius 8px
    text-align center
</style>
<script name='json'>
  module.exports = {
    component: true,
    usingComponents: {
      'es-icon': '@didi/es-mpx-ui/lib/icon'
    }
  }
</script>
